import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import {
  GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT,
  GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_ERROR,
  GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_SUCCESS,
} from '../../actions.js';

function* getBookingTypeForTicketManagement({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/booking-type-list-for-ticket-management`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT_ERROR, payload: error });
  }
}

export function* watchGetBookingTypeForTicketManagement() {
  yield takeEvery(GET_BOOKING_TYPE_FOR_TICKET_MANAGEMENT, getBookingTypeForTicketManagement);
}

function* getBookingTypeForTicketManagementSaga() {
  yield all([fork(watchGetBookingTypeForTicketManagement)]);
}

export default getBookingTypeForTicketManagementSaga;
